import React, {useEffect, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {verifyPayment} from "../../reduxLib/paymentLib";
import {useDispatch, useSelector} from "react-redux";
import {fetchOrderById} from "../../reduxLib/ordersLib";
import {emptyShoppingCard} from "../../reduxLib/shoppingcardLib";
import voidPuroductCard from "../../cookieStorage/voidPuroductCard";
import resetProductCard from "../../cookieStorage/ResetProductCard";

function PaymentContainer()
{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    console.log("Session ID from query params:", sessionId);
    const {session_id} = useParams();
    const confirmation = useSelector(state => state.paymentreducer.paymentVerification);
    const loading = useSelector(state => state.paymentreducer.status);

    const [orderId,setOrderId]=useState(0);
    const [dateOrd,setOrderDate]=useState("");
    const [total,setTotal]=useState(0);
    const [mail,setMail]=useState("");


    useEffect(() => {
        const loadOrder = async () => {
            if (!sessionId) return;

            try {
                const paymentData = await dispatch(verifyPayment(sessionId)).unwrap();

                console.log("paymentData:", paymentData);

                if (paymentData?.status === "complete") {
                    const id = paymentData.orderId;

                    setOrderId(id);

                    const orderData = await dispatch(fetchOrderById(id)).unwrap();

                    console.log("orderData:", orderData);

                    setOrderDate(orderData.dateCreated);
                    setTotal(orderData.total);
                    setMail(orderData.orderOwnerEmail);
                   // await voidPuroductCard();
                    //await resetProductCard();
                }
            } catch (error) {
                console.error("Payment/order fetch failed:", error);
               // navigate(`/checkout/error`);
            }
        };

        loadOrder();
        resetProductCard();


    }, [sessionId, dispatch]);


    return (
        <div>
            <main className="bg-cream font-sc">
                <section id="success-hero" className="py-20">
                    <div className="max-w-4xl mx-auto px-6">
                        <div className="bg-white rounded-3xl shadow-2xl p-12 text-center">
                            <div id="success-icon" className="mb-8">
                                <div
                                    className="w-32 h-32 bg-brand-green rounded-full flex items-center justify-center mx-auto animate-pulse">
                                    <i className="fas fa-check text-white text-6xl"></i>
                                </div>
                            </div>

                            <div id="success-message" className="mb-8">
                                <h1 className="text-5xl font-serif font-bold text-gray-800 mb-4">Payment
                                    Successful!</h1>
                                <p className="text-xl text-gray-600 mb-2">Thank you for your order</p>
                                <p className="text-lg text-gray-500">Your handcrafted baskets are on their way</p>
                            </div>

                            <div id="order-details" className="bg-cream rounded-2xl p-8 mb-8">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
                                    <div>
                                        <div className="flex items-center space-x-3 mb-3">
                                            <i className="fas fa-receipt text-brand-green text-xl"></i>
                                            <span className="text-gray-500 font-medium">Order Number</span>
                                        </div>
                                        <p className="text-2xl font-bold text-gray-800 ml-8">#{orderId}</p>
                                    </div>

                                    <div>
                                        <div className="flex items-center space-x-3 mb-3">
                                            <i className="fas fa-calendar-check text-brand-green text-xl"></i>
                                            <span className="text-gray-500 font-medium">Order Date</span>
                                        </div>
                                        <p className="text-2xl font-bold text-gray-800 ml-8">{dateOrd
                                            ? new Date(dateOrd).toLocaleDateString("en-GR", {
                                                day: "2-digit",
                                                month: "long",
                                                year: "numeric",
                                            })
                                            : "-"}</p>
                                    </div>

                                    <div>
                                        <div className="flex items-center space-x-3 mb-3">
                                            <i className="fas fa-euro-sign text-brand-green text-xl"></i>
                                            <span className="text-gray-500 font-medium">Total Amount</span>
                                        </div>
                                        <p className="text-2xl font-bold text-brand-green ml-8">€{total}</p>
                                    </div>
                                </div>
                            </div>

                            <div id="confirmation-email"
                                 className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8">
                                <div className="flex items-start space-x-4">
                                    <i className="fas fa-envelope-open-text text-blue-600 text-3xl mt-1"></i>
                                    <div className="text-left">
                                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Confirmation Email
                                            Sent</h3>
                                        <p className="text-gray-600">We've sent a confirmation email to <span
                                            className="font-semibold text-gray-800">{mail}</span> with your
                                            order details and tracking information.</p>
                                    </div>
                                </div>
                            </div>

                            <div id="action-buttons" className="flex flex-col sm:flex-row gap-4 justify-center">

                                <button
                                    onClick={() => navigate('/products', { replace: true })}
                                    className="bg-white hover:bg-gray-50 text-brand-green border-2 border-brand-green font-semibold px-8 py-4 rounded-xl transition-colors duration-300 flex items-center justify-center space-x-2">
                                    <i className="fas fa-shopping-bag text-xl"></i>
                                    <span>Continue Shopping</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="next-steps" className="py-20 bg-cream">
                    <div className="max-w-6xl mx-auto px-6">
                        <h2 className="text-4xl font-serif font-bold text-gray-800 mb-12 text-center">What Happens
                            Next?</h2>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            <div id="step-1" className="bg-white rounded-2xl p-8 text-center shadow-md">
                                <div
                                    className="w-20 h-20 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                    <i className="fas fa-box-open text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-serif font-semibold mb-4 text-gray-800">Order
                                    Processing</h3>
                                <p className="text-gray-600 leading-relaxed">Our artisans will carefully prepare your
                                    handcrafted baskets for shipment within 1-2 business days.</p>
                            </div>

                            <div id="step-2" className="bg-white rounded-2xl p-8 text-center shadow-md">
                                <div
                                    className="w-20 h-20 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                    <i className="fas fa-shipping-fast text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-serif font-semibold mb-4 text-gray-800">Shipping</h3>
                                <p className="text-gray-600 leading-relaxed">Your order will be shipped with care. You will be informed for the status by email.</p>
                            </div>

                            <div id="step-3" className="bg-white rounded-2xl p-8 text-center shadow-md">
                                <div
                                    className="w-20 h-20 bg-brand-green rounded-full flex items-center justify-center mx-auto mb-6">
                                    <i className="fas fa-home text-3xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-serif font-semibold mb-4 text-gray-800">Delivery</h3>
                                <p className="text-gray-600 leading-relaxed">Receive your beautiful handmade baskets at
                                    your doorstep and enjoy their timeless quality.</p>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </div>

    );
}

export default PaymentContainer;